import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";
import moment from "moment";
import "moment/locale/es";

export const Facturas = ({ facturas, vam }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Facturas"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th className="text-left">Item</th>
                                        <th className="text-left">No. Factura</th>
                                        <th className="text-left">Fc Emisión</th>
                                        <th className="text-left">Proveedor</th>
                                        <th className="text-right">Valor</th>
                                        {vam && (
                                            <>
                                                <th className="text-right">Val No Cubierto</th>
                                                <th className="text-right">Val Cubierto</th>
                                                <th className="text-right">Val Pagado</th>
                                                <th className="text-left">Aprobado</th>
                                            </>
                                        )}
                                        <th className="text-left">Observaciones</th>
                                        {!vam && (
                                            <>
                                                <th className="text-left">Cobertura</th>
                                            </>
                                        )}
                                        {vam && (
                                            <>
                                                <th className="text-left">Beneficios</th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {facturas.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={12}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {facturas.map((item, index) => (
                                                <tr key={item.cdGastosVam}>
                                                    <td>
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.numRecibo}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        {item.fcGasto
                                                            ? moment(item.fcGasto)
                                                                  .locale("moment/locale/es")
                                                                  .local()
                                                                  .format("DD/MMM/YYYY")
                                                            : null}
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.detalle}</span>
                                                    </td>
                                                    <td className="text-right" style={{ width: 150 }}>
                                                        <ReactNumeric
                                                            valuex={item.valor ? item.valor : 0}
                                                            readOnly
                                                            className="form-control-plaintext"
                                                        />
                                                    </td>
                                                    {vam && (
                                                        <>
                                                            <td className="text-right" style={{ width: 80 }}>
                                                                <ReactNumeric
                                                                    valuex={item.valNoCubierto ? item.valNoCubierto : 0}
                                                                    readOnly
                                                                    className="form-control-plaintext "
                                                                />
                                                            </td>
                                                            <td className="text-right">
                                                                <ReactNumeric
                                                                    valuex={item.valorAPagar ? item.valorAPagar : 0}
                                                                    readOnly
                                                                    className="form-control-plaintext text-right"
                                                                />
                                                            </td>
                                                            <td className="text-right">
                                                                <ReactNumeric
                                                                    valuex={item.valorPagado ? item.valorPagado : 0}
                                                                    readOnly
                                                                    className="form-control-plaintext text-right"
                                                                />
                                                            </td>
                                                            <td className="text-left">
                                                                <span>{item.aprobado ? "SI" : "NO"}</span>
                                                            </td>
                                                        </>
                                                    )}
                                                    <td className="text-left">
                                                        <span>{item.obsGastoVam}</span>
                                                    </td>
                                                    {!vam && (
                                                        <td className="text-left">
                                                            <span>{item.nmCobertura}</span>
                                                        </td>
                                                    )}
                                                    <td>
                                                        <span>{item.nmCobertura}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
